import { h as __h } from "preact";
import { Component } from "preact";
import html from "~/util/html.js";
import Icon from "~/component/Icon.js";
/** @import { machineResponse } from "~/backend/validate.js"; */

import adminStyle from "~/admin/lib/style.js";

/**
 * @extends {Component<Props>}
 *
 * @typedef {object} Props
 * @property {Pick<machineResponse, "id" | "org_id" | "name">} machine
 */
export default class ComputerChip extends Component {
  render() {
    const {
      machine
    } = this.props;
    return __h("a", {
      href: "/org/" + machine.org_id + "/computers/" + machine.id,
      "class": adminStyle.chip
    }, __h(Icon, {
      name: "machine",
      size: 12
    }), __h("span", {}, machine.name));
  }
}